import { ColumnHeadersVariant } from 'libs/ui/Table/types';

export const COLUMN_HEADER_TITLE_FONT_SIZES: Record<
  ColumnHeadersVariant,
  number
> = {
  standard: 14,
  small: 12,
};
